import React, { useEffect } from "react";
import DateRangePicker from "./DateRangePicker";
import { useState } from "react";
import { WebService } from "../../Services/WebService";
import { StandardConst } from "../../Services/StandardConst";
import TableComponent, {
  NoRecordTemplate,
} from "../../Services/TableComponent";
import { Button, Container } from "react-bootstrap";
import ActionButton from "../../Services/ActionButton";
import AddEditSalesVisits from "./AddEditSalesVisits";
import { useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { WSSuccessAlert } from "../../Services/WSAlert";
import DeleteConfirmAlert from "../../Services/AlertComponent";
import { ActionPermission } from "../PageInfo";
import Topbar from "../../Services/TopbarComponent";
import { Box } from "@mui/material";
import { format } from "date-fns";
import { map } from "underscore";
import { DateTime } from "luxon";

import ViewSalesVisit from "./ViewSalesVisit";

function Sales() {
  const [fetchingdata, setfetchingdata] = useState(false);
  const [Record, setRecord] = useState([]);
  const [selectedImage, setSelectedImage] = useState(null);
  const [DateRange, setDateRange] = useState();
  const addEditModalRef = useRef();
  const [Persons, setPersons] = useState([]);
  const loggedUser = useSelector((s) => s.auth.LoggedUser ?? 0);
  const [FilteredRecords, setFilteredRecords] = useState([]);
  const [personfilter, setPersonfilter] = useState([]);
  const dispatch = useDispatch();
  const refDelete = useRef();
  const [filters, setfilters] = useState({});
  const [permission, setPermission] = useState({});
  const permissionList = useSelector((s) => s.auth.PermissionList ?? []);
  const viewModalRef = useRef();
  useEffect(() => {
    setPermission({
      CanFillCustomerVisitForm: ActionPermission("Sales-customer-visit-form"),
      CanSeeCustomerReport: ActionPermission("Sales-view-customer-report"),
      CanSeeVisitReport: ActionPermission("Sales-view-visit-report"),
      canSeeEmployeeDropdown: ActionPermission("Sales-Filter-EmployeeList"),
    });
  }, [permissionList]);

  const fetchData = async (filter = {}) => {
    try {
      setfetchingdata(true);
      // Build query parameters based on what’s available
      let queryParams = `?startDate=${filter.FromDate}&endDate=${filter.ToDate}`;

      if (
        filter.EmployeeId &&
        filter.EmployeeId.length > 0 &&
        filter.EmployeeId[0]?.EmployeeId
      ) {
        queryParams += `&executiveId=${filter.EmployeeId?.[0]?.EmployeeId}`;
      }
      if (
        filter.DateRange &&
        filter.DateRange.length > 0 &&
        filter.DateRange[0]?.value
      ) {
        queryParams += `&rangeType=${filter.DateRange?.[0]?.value}`;
      }

      const data = await WebService({
        endPoint: `sales2/sales-visits${queryParams}`,
        dispatch,
      });
      setRecord(data.visits);
      setFilteredRecords(data.visits);
      setPersons([{ EmployeeId: 0, FullName: "All" }, ...data.reportees]);
      const executiveData = map(data.reportees, (m) => ({
        EmployeeId: m?.EmployeeId,
        heading: m?.FullName,
        description: m?.Designation,
        avatar: `${StandardConst.apiBaseUrl}/uploads/${m?.ProfileImage}`,
        text: m?.FullName,
        value: m?.EmployeeId,
      }));
      setPersons(
        [{ EmployeeId: 0, heading: "All Person" }].concat(executiveData)
      );
      setPersonfilter([{ EmployeeId: 0, FullName: "All" }]);
    } catch (error) {
      console.error("Error fetching sales visits:", error);
    } finally {
      setfetchingdata(false);
    }
  };
  const fetchdatawithexistingDaterange = async (filter = {}) => {
    setfilters(filter);
    await fetchData(filter);
  };
  const canEditDelete = (dr) => {
    // let isDateOneDayOlder =
    //   new Date(dr.startTime).getTime() < new Date(Date.now() - 24 * 60 * 60 * 1000);
    // console.log(isDateOneDayOlder);
    // return (
    //   dr.EmployeeId === loggedUser &&
    //   permission.CanFillCustomerVisitForm &&
    //   !isDateOneDayOlder
    // );
    return true;
  };

  const fnEdit = async (id) => await addEditModalRef.current.openModal(id || 0);
  const fnDelete = async (id) => {
    await WebService({
      endPoint: `CommonUtility/visits?visitId=${id}`,
      method: "DELETE",
      dispatch,
    }).then((_) => {
      WSSuccessAlert("Success", " deleted successfully");
      fetchdatawithexistingDaterange(filters);
    });
  };
  const columns = [
    {
      Text: "scheduled Date",
      Value: "scheduledDate",
      render: (dr) => (
        <span className="col-auto">
          {format(new Date(dr.scheduledDate), "dd MM yyyy, hh:mm a")}
        </span>
      ),
    },
    {
      Text: "Business",
      Value: "BussinessName",
    },
    {
      Text: "Customer",
      Value: "name",
    },
    {
      Text: "Phone",
      Value: "phone",
    },
    {
      Text: "Email",
      Value: "email",
    },
    {
      Text: "executive",
      Value: "executiveName",
    },

    {
      Text: "location",
      render: (dr) => (
        
        <span>
          <a
            href={`https://www.google.com/maps?q=${dr?.startLocationLat},${dr?.startLocationLong}`}
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-600 underline"
          >
            {console.log(dr,'abhi babu')}
            {dr.startLocationLat}, {dr.startLocationLong}
          </a>
        </span>
      ),
    },
    {
      Text: "Action",
      key: "OfficeLocationId",
      cssClass: "text-center td-width-100",
      render: (dr) =>
        canEditDelete(dr) && (
          <>
            <div className="d-flex">
              <ActionButton
                IconTooltip="view"
                onClick={() => viewModalRef.current.openModal(dr)}
                IconName="View"
                id="viewvisit"
              />
              <ActionButton
                IconTooltip="edit"
                onClick={() => fnEdit(dr.visitId)}
                IconName="Edit"
                id="editvisit"
              />
              <ActionButton
                IconTooltip="delete"
                onClick={() =>
                  refDelete.current.confirmAlert(
                    "Delete", //Confirm button text
                    "Are You Sure", // Text if Alert
                    "Do you want to delete ", // Message of Alert
                    dr.visitId
                  )
                }
                IconName="Delete"
                id="deletevisit"
              />
            </div>
          </>
        ),
    },
  ];
  useEffect(() => {
    if (
      !personfilter ||
      personfilter.length === 0 ||
      personfilter[0].EmployeeId === 0
    ) {
      setFilteredRecords(Record);
    } else {
      const selectedIds = personfilter.map((p) => p.EmployeeId);
      const filteredRecords = Record.filter((record) =>
        selectedIds.includes(record.EmployeeId)
      );
      setFilteredRecords(filteredRecords);
    }
  }, [personfilter]);
  let MasterPageName = "Manage Customer Visits";
  let AddButtonText = "Customer Visit";
  const [bData, setBData] = React.useState([
    {
      title: "Company",
      hrefLink: "#",
    },
    {
      title: "Customer Visits",
      hrefLink: "#",
    },
  ]);
  const topbar = <Topbar bData={bData} HeadingText={MasterPageName}></Topbar>;
  return (
    permission.CanSeeVisitReport && (
      <Container fluid className="base-container">
        <DeleteConfirmAlert ref={refDelete} confirmEvent={(v) => fnDelete(v)} />
        <Box
          sx={{
            width: 1,
          }}
        >
          {topbar}
        </Box>
        <TableComponent
          columns={columns}
          data={FilteredRecords}
          IsAddButtonVisible={permission.CanFillCustomerVisitForm}
          isSearchRequired={true}
          ExcluedFieldFromColumns={["Coordinates"]}
          ExcelExportFieldNames={[
            {
              ExcelColumnHeading: "latitude",
              DataColumnName: "locationLat",
            },
            {
              ExcelColumnHeading: "longitude",
              DataColumnName: "locationLat",
            },
            {
              ExcelColumnHeading: "remarks",
              DataColumnName: "remarks",
            },
          ]}
          allowSerialNo={true}
          onAddEvent={() => fnEdit()}
          noRecordCss="p-0"
          filterData={[
            permission.canSeeEmployeeDropdown && {
              FieldName: "EmployeeId",
              FilterType: "AUTOCOMPLETE",
              OptionText: "heading",
              FilterData: Persons,
            },
            {
              FieldName: "FromDate",
              DefaultDate: DateTime.local().endOf("month").minus({ months: 1 }),
              FilterType: "DATE",
              FilterPlaceholder: "Enter From Date",
            },
            {
              FieldName: "ToDate",
              DefaultDate: DateTime.local().endOf("month"),
              FilterType: "DATE",
              FilterPlaceholder: "Enter To Date",
            },
          ].filter(Boolean)} // removes false/undefined
          callBackEvent={fetchdatawithexistingDaterange}
          noRecordFound={
            <NoRecordTemplate
              headerValue="No customer visit record found"
              subHeaderValue="No Sales record found"
              imageUrl={StandardConst.imageNoRecordsFound}
              actionButton={
                <>
                  {permission.CanFillCustomerVisitForm && (
                    <Button
                      variant="outline-primary"
                      // onClick={() => fnEdit(0)}
                      id={`no_record_add_${AddButtonText}`}
                    >
                      Add {AddButtonText}
                    </Button>
                  )}
                </>
              }
            />
          }
        />
        <AddEditSalesVisits
          callBackEvent={() => fetchdatawithexistingDaterange(filters)}
          ref={addEditModalRef}
        ></AddEditSalesVisits>

        <ViewSalesVisit ref={viewModalRef} />
      </Container>
    )
  );
}

export default Sales;
